import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import "./Testimonials.css"

function Testimonials(props) {
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
          slidesToSlide: 3, // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
          slidesToSlide: 2, // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          slidesToSlide: 1, // optional, default to 1.
        },
      };
  return (
    <div style={{marginTop : "80px"}}>
        <ScreenHeading title={"Feedbacks"} />
        <section id={props.id || ""}>
            <div className='testmonials-container'>
                <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={true}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    infinite={true}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                    >
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                        <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed6.jpg").default} />
                    </div>
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                    <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed5.jpg").default} />
                    </div>
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                    <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed4.jpg").default} />
                    </div>
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                    <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed3.jpg").default} />
                    </div>
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                    <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed2.jpg").default} />
                    </div>
                    <div style={{minHeight : "300px", minWidth : "300px", background :"white", margin : "0 20px"}}>
                    <img style={{width : "300px", height : "420px"}} src={require("../../assets/Testimonial/feed1.jpg").default} />
                    </div>
                </Carousel>
            </div>
        </section>
    </div>
  )
}

export default Testimonials